
import { createContext } from "react";
import { HalfwayContextType } from "../types/HalfwayContextType";

export const HalfwayContext = createContext<HalfwayContextType | null>(null);
